import { attr as o } from "@microsoft/fast-element";
import { tablePaginationStyles as l } from "./table-pagination.styles.js";
import { tablePaginationTemplate as g } from "./table-pagination.template.js";
import { Pagination as c } from "../pagination/index.js";
import { JsonValueConverter as f } from "../common/converters/json-value-converter.js";
import h from "./table-pagination.i18n.js";
import { NumberStringConverter as u } from "../common/converters/number-string-converter.js";
import { forceUpdate as v } from "../common/force-update.js";
var d = Object.defineProperty, a = (p, t, s, S) => {
  for (var e = void 0, i = p.length - 1, m; i >= 0; i--)
    (m = p[i]) && (e = m(t, s, e) || e);
  return e && d(t, s, e), e;
};
const n = class n extends c {
  constructor() {
    super(...arguments), this.tpi18n = h, this.pageSize = 0, this.pageSizeOptions = [];
  }
  pageSizeChanged() {
    this.$fastController.isConnected && v(this);
  }
  handlePageSizeChange(t) {
    t && this.$emit("page-size", Number(t.eventDetail().currentValue), {
      cancelable: !1
    });
  }
};
n.definition = {
  name: "table-pagination",
  template: g,
  styles: () => l
};
let r = n;
a([
  o({ converter: f })
], r.prototype, "tpi18n");
a([
  o({ converter: u })
], r.prototype, "pageSize");
a([
  o({
    converter: f
  })
], r.prototype, "pageSizeOptions");
export {
  r as TablePagination
};
